// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"0566ff85","201":"e0045bcf","202":"01232473","532":"a52f4b74","578":"14b81aff","634":"cba8cb48","716":"3bcf6c82","881":"b2ad50ea"}[chunkId] + ".chunk.js";
};